import { SignupTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const SignupTrackingSchema: Record<SignupTrackingPoint, string> = {
  [SignupTrackingPoint.SignupPageView]: 'e3631af-9cb5-4d3c-ad0a-75f339983b30',
  [SignupTrackingPoint.SignupHelpButtonClick]:
    '282c47e3-c006-4862-898f-f9c4bb22ba0c',
  [SignupTrackingPoint.SignupNextButtonClick]:
    '10be384d-5ff4-4043-9f68-3c3eb752a279',
  [SignupTrackingPoint.EnterpriseAccountSubmitFormButtonClick]: '',
  [SignupTrackingPoint.PhoneAlreadyRegisteredPageView]:
    'ed93a239-862f-4037-b4de-27f1ab7e626a',
  [SignupTrackingPoint.PhoneAlreadyRegisteredLoginButtonClick]:
    'a79db340-e829-42b7-8ba9-e9e7146da400',
  [SignupTrackingPoint.PhoneAlreadyRegisteredContactUsButtonClick]:
    '4513b1ab-c9fb-4115-a770-fc214ce7d18a',
  [SignupTrackingPoint.PhoneAlreadyRegisteredHelpButtonClick]:
    '3bb56268-2e1d-41e3-ac5a-ec0162b5282f',
  [SignupTrackingPoint.EmailAlreadyRegisteredPageView]:
    '72b746ef-574d-4de7-ad98-e72c459ff6ff',
  [SignupTrackingPoint.EmailAlreadyRegisteredLoginButtonClick]:
    '370720d5-dda0-422f-8a6e-ef98f7511804',
  [SignupTrackingPoint.EmailAlreadyRegisteredContactUsButtonClick]:
    '5aa84559-4f7a-4eca-a71e-b3a62a3c3b91',
  [SignupTrackingPoint.EmailAlreadyRegisteredHelpButtonClick]:
    'a6111478-f82f-4e0b-8598-722299685bf8',
  [SignupTrackingPoint.SignupSetPasswordPageView]:
    '59273f28-a19b-46ca-b9ca-89b5db2da28c',
  [SignupTrackingPoint.SignupSetPasswordSignupButtonClick]:
    '85b63664-b345-4cf8-9324-253880afdc91',
  [SignupTrackingPoint.SignupSetPasswordBackButtonClick]:
    '1127d32d-e358-49fe-a798-2ecd6d72b8ce',
  [SignupTrackingPoint.SignupSuccessPageView]:
    'c4858bfb-c088-48d6-8944-ec0981df4923',
  [SignupTrackingPoint.SignupSuccessPageNextButtonClick]:
    '41d03ff8-76d8-46a8-9687-c213f9300c56',
  [SignupTrackingPoint.SignupSuccessPageBackButtonClick]:
    '3630f074-cb77-4703-a44d-4728b645605d',
  [SignupTrackingPoint.SignupSuccessAction]:
    '0b7013d5-9a39-4cb3-9c4d-45fcbe159229',
  [SignupTrackingPoint.QuickLoginToggleImpression]:
    '569a7598-31fa-4d6d-99ed-17a5898f416f',
  [SignupTrackingPoint.QuickLoginToggleClick]:
    '27d321aa-94f5-47c9-b378-6ec8b87f168c',
  [SignupTrackingPoint.QuickLoginTooltipImpression]:
    'b9b4b2e3-bcf9-4b83-a1bf-ca3ef3a89e17',
  [SignupTrackingPoint.QuickLoginActionSuccess]:
    '27887dba-2f13-455f-b06e-75b70856e5b9',
  [SignupTrackingPoint.LoginSuccessAction]:
    'd53a6c58-5789-4d99-9921-705b597473e9',
};

export const getSignupSetPasswordPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupSetPasswordPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupSuccessPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupSuccessPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupAccountPhoneAlreadyRegisteredPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupPhoneAlreadyRegisteredPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};

export const getSignupAccountEmailAlreadyRegisteredPageTypeAndSchema = (
  trackingPoint: SignupTrackingPoint
) => {
  return {
    page_type: PageType.SignupEmailAlreadyRegisteredPage,
    schema: SignupTrackingSchema[trackingPoint],
  };
};
